
import styled from 'styled-components';
import { ShadowBoxDark } from 'app/components';
import { RowButton } from '../styles';
export const StepSnacksAside = styled(ShadowBoxDark).attrs({
  className: 'b-step-snacks__aside'
})`
  width: 329px;
  height:694px;
  // padding: ${({ theme }) => theme.indent.m};

  ${RowButton} {
    text-align: center;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    width: 100%;
    padding: 0;
    background: none;
    box-shadow: none;
    height: 60px
  }
`;